var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "title": "Close Image"
    },
    on: {
      "keyDown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        _vm.$emit('moveLeft')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        _vm.$emit('moveRight')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.$emit('close')
      }],
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "title": ""
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "modal-img",
    attrs: {
      "title": _vm.piece.label,
      "alt": _vm.piece.label,
      "src": _vm.urlPrefix + _vm.piece.url
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "direction-button left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('moveLeft')
      }
    }
  }, [_vm._v("\n          Previous\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "direction-button right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('moveRight')
      }
    }
  }, [_vm._v("\n          Next\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-text"
  }, [_vm._v("\n        " + _vm._s(_vm.piece.label) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-text"
  }, [_vm._v("\n        " + _vm._s(_vm.piece.size) + "\n      ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67567d5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = qrmn
// module chunks = 1